<template>
  <div>
    <div id="filter-group">
      <div id="date-filter" v-if="statusFilter === 'Fechado'">
        <label for="" >De</label>
        <input type="date" class="form-control custom-width" :disabled="statusFilter !== 'Fechado'" v-model="filters.startDate">
        <label for="" >Até</label>
        <input type="date" class="form-control custom-width" :disabled="statusFilter !== 'Fechado'" v-model="filters.endDate">
        <button type="button" id="search-button" class="btn mb-0 filter-buttons" :disabled="statusFilter !== 'Fechado'" @click="getPedidos()">
          <i class="fa fa-search" aria-hidden="true"></i>   Buscar
        </button>
        <button type="button" id="reset-button" class="btn mb-0 filter-buttons" @click="resetFilters()">
          <i class="fa fa-times" aria-hidden="true"></i>   Limpar
        </button>
      </div>
      <div class="search-container">
        <input 
          type="text" 
          class="form-control custom-width" 
          placeholder="Pesquisar..." 
          v-model="searchTerm"
          style="width: 100%;"
        >
      </div>
      <div class="d-flex">
        <div class="header-filter">
          <label for="header-filter">Área</label>
          <select v-model="sectorFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="">Não atribuído</option>
            <option>N1 - Atendimento a Clientes</option>
            <option>N2 - Suporte e Gestão de Serviços</option>
            <option>N2 - Gestão de Cofre Inteligente</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Status</label>
          <select v-model="statusFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="ativo" selected>Aberto e em andamento</option>
            <option>Aberto</option>
            <option>Em andamento</option>
            <option>Fechado</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Tipo</label>
          <select v-model="typeFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="Whatsapp">Whatsapp</option>
            <option value="URA">URA</option>
            <option value="Formulário">Formulário</option>
            <option value="E-mail">E-mail</option>
          </select>
        </div>
        <div class="header-filter">
          <label for="header-filter">Desvio de procedimento</label>
          <select v-model="deviationFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="sim">Sim</option>
            <option value="nao">Não</option>
          </select>
        </div>
      </div>
    </div>
    <hr>

    <b-button variant="success" style="margin-right: -4px;" @click="generateExcel">EXCEL <b-icon icon="file-earmark-excel" aria-hidden="true"></b-icon></b-button>

    <br>

    <b-row class="justify-content-between" style="overflow-x: auto">
      <b-col md="12">

    <b-table
        striped
        hover
        bordered
        sort-icon-left
        show-empty
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="filteredItems"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        :current-page="currentPage"
        :per-page="perPage"
        thead-class="font-weight-bold"
        :sort-compare="sortDate"
    >
      <template #empty="">
        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
      </template>

      <!-- Formatar campo data -->
      <template #cell(telefone)="data">
        {{ formTelefone(data.item.telefone) }}
      </template>

      <!-- Formatar campo data -->
      <template #cell(cnpj)="data">
        {{ (data.item.cnpj == 0) ? 'Não informado' : data.item.cnpj  }}
      </template>

      <!-- Formatar campo status -->
      <template #cell(status)="data">
        {{ data.item.status }}
      </template>

      <!-- Formatar campo status -->
      <template #cell(protocolo)="data">
        {{ !data.item.protocolo ? '---' : data.item.protocolo }}
      </template>

      <template #cell(chamado)="data">
        {{ !data.item.chamado ? '---' : data.item.chamado }}
      </template>

      <!-- Formatar campo telefone -->
      <template #cell(created_at)="data">
        {{ moment(data.item.created_at).format('DD/MM/YYYY \à\\s HH:mm') }}
      </template>

      <template #cell(updated_at)="data">
        {{ moment(data.item.updated_at).format('DD/MM/YYYY \à\\s HH:mm') }}
      </template>

      <template #cell(sector)="data">
        {{ data.item.sector || 'Não atribuído' }}
      </template>

      <!-- Nome Fantasia -->
      <template #cell(dados)="data">
       {{ getNomePonto(data.item.dados) }}
      </template>

      <!-- Coluna Razão Social -->
      <template #cell(razao_social)="data">
        {{ getRazaoSocial(data.item.dados) }}
      </template>

      <!-- Coluna Tipo de Atendimento -->
      <template #cell(tipo_atendimento)="data">
        {{  data.item.channel ? data.item.channel : data.item.tipo_atendimento }}
      </template>

      <template #cell(created_by)="data">
        {{ parseCreator(data.item) }}
      </template>

      <template v-slot:cell(view-button)="{ item }">
        <span>
          <b-btn style="background-color: #1c869a" id="view-button" @click.prevent="getMsgLog(item)">
               <i class="fas fa-eye fa-fw"></i>
          </b-btn>
        </span>
      </template>

    </b-table>

      </b-col>
    </b-row>

    <b-row class="justify-content-between">
      <b-col md="4">
        <b-form-group
            label="Registros por página"
            label-for="per-page-select"
            label-cols-md="6"
            label-align-sm="right"
            label-size="sm"
            class="mb-0 align-self-center"
        >
          <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="md"
            class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <dtModalPedidos ref="dtModalPedidos" v-on:reload="getPedidos()" v-if="getlogchat && Object.keys(getlogchat).length"/>

  </div>

</template>

<script>
import {mapMutations, mapGetters} from 'vuex';
import * as XLSX from 'xlsx';
import moment from 'moment';

export default {
  props: {
    emailGroups: {
      type: Array,
      default: () => []
    },
    wppGroups: {
      type: Array,
      default: () => []
    },
    autoOpenProtocol: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      moment: moment,
      fields: [
        { key: 'created_at', label: 'Data de Criação', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true, sortByFormatted: true },
        { key: 'created_by', label: 'Criado por', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'updated_at', label: 'Data de Alteração', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'updated_by', label: 'Alterado por', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'chamado', label: 'Chamado', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'protocolo', label: 'Protocolo', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'status', label: 'Status', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'telefone', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'cnpj', label: 'CNPJ', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'dados', label: 'Estabelecimento', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'razao_social', label: 'Razão Social', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'sector', label: 'Área Responsável', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'tipo_atendimento', label: 'Canal', class: 'text-center', thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        {
          key: 'view-button',
          label: 'Visualizar',
          sortable: true,
          class: 'text-center',
          thStyle: {backgroundColor: '#1c869a', color: '#ffffff', width: '100px'}
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
      sortBy: 'created_at',
      sortDesc: false,
      filter: null,
      filterOn: [],
      filters: {
        startDate: '',
        endDate: '',
      },
      items: [],
      searchTerm: '',
      sectorFilter: '*',
      statusFilter: 'ativo',
      typeFilter: '*',
      deviationFilter: '*',
      autoOpenTriggered: false
    }
  },
  computed:{
    ...mapGetters(['getlogchat']),
    totalRows(){
      return this.filteredItems.length;
    },
    filteredItems(){
      let tempArray = this.items;

      if(this.statusFilter !== '*'){
        if(this.statusFilter === 'ativo'){
          tempArray = tempArray.filter(el => el.status === 'Em andamento' || el.status === 'Aberto')
        } else {
          tempArray = tempArray.filter(el => el.status === this.statusFilter)
        }
      }

      if(this.sectorFilter !== '*') tempArray = tempArray.filter(el => el.sector === this.sectorFilter)
      if(this.typeFilter !== '*') tempArray = tempArray.filter(el => el.tipo_atendimento === this.typeFilter)
      if(this.deviationFilter !== '*') tempArray = tempArray.filter(el => !!el.procedure_deviation?.has_deviation === (this.deviationFilter === 'sim'))
      if(this.searchTerm !== '') tempArray = tempArray.filter(el => {
        const keyword = this.searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\s]/g, '');
        return [
          el.protocolo,
          el.chamado,
          el.name,
          el.contato,
          el.cnpj,
          el.razao_social,
          el.created_by,
          el.updated_by,
          el.nomeCliente,
          el.nomePonto,
          el.sector
        ].some(
          field => field && field.toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^\w\s]/g, '')
          .includes(keyword)
        );
      })

      return tempArray;
    }
  },
  methods : {
    ...mapMutations(['setLogChat']),

  parseAttendanceType(item){
    if(item.channel){
      if(item.channel === 'whatsapp' || item.channel === 'wpp') return 'Whatsapp'
      if(item.channel === 'phone') return 'URA'
      return item.channel
    }
    if(item.client === 'RequestByPhone') return 'URA';
    if(item.client_id.includes('whatsapp')) return 'Whatsapp';
    return 'Formulário'
  },
  getNomePonto(dados) {
    try {
      if (!dados) return '---';
      const parsed = typeof dados === 'string' ? JSON.parse(dados) : dados;
      return parsed?.[0]?.NomePonto || '---';
    } catch (e) {
      return '---';
    }
  },
  getRazaoSocial(dados) {
    try {
      if (!dados) return '---';
      const parsed = typeof dados === 'string' ? JSON.parse(dados) : dados;
      return parsed?.[0]?.NomeCliente || '---';
    } catch (e) {
      return '---';
    }
  },
  sortDate(a, b, key) {
      if (key !== 'created_at' && key !== 'updated_at') {
        return null;
      }
      let aDate = moment(a[key], 'YYYY-MM-DD HH:mm:ss')
      let bDate = moment(b[key], 'YYYY-MM-DD HH:mm:ss')
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1
        }
        else if (aDate > bDate) {
          return 1
        }
        else {
          return 0
        }
      }
      return null
    },

    onFiltered(filteredItems) {
      this.currentPage = 1
    },

    async getMsgLog(item){
      let survey = {}
      let emailData = null;
      if(item.protocolo){
        survey = await axios.get(`/solicitacoes/getSatisfactionDetails/${item.protocolo}`).then(({data}) => {
          if(data){
            return data
          }
          return {}
        })
      }
      if(item.protocolo){
        emailData = await axios.get('/solicitacoes/getEmailsByProtocol', {params: {protocol: item.protocolo}}).then(({data}) => { return data || null })
      }
      const clientData = (item.dados) ? JSON.parse(item.dados) : [];
      const orderData = JSON.parse(item.solicitacao)
      const infoModal =  {
          _id: item._id,
          tipo_solicitacao: item.requirement_type,
          tipo_atendimento: item.tipo_atendimento,
          solicitacao: orderData.solicitacao,
          tipo: orderData.tipo,
          quantidade: orderData.quantidade,
          nome: item.name || orderData.nome,
          contato: this.formTelefone(item.telefone),
          cnpj: item.cnpj,
          status: item.status,
          chamado: item.chamado,
          protocolo: item.protocolo,
          NomeCliente: clientData?.[0]?.NomeCliente || '---',
          endereco: clientData?.[0]?.EnderecoPonto || '---',
          cep: clientData?.[0]?.CEPCliente || '---',
          nomePonto: clientData?.[0]?.NomePonto || '---',
          codigoPonto: clientData?.[0]?.CodigoPonto || '---',
          Base: clientData?.[0]?.Base || '---',
          created_at: moment(item.created_at).format('DD/MM/YYYY \à\\s HH:mm'),
          updated_at: moment(item.updated_at).format('DD/MM/YYYY \à\\s HH:mm'),
          recordType: item.recordType,
          updated_by: item.updated_by,
          created_by: this.parseCreator(item),
          id: item.client_id || item.id,
          feedback: item.feedback || {},
          notes: item.notes || [],
          sector: item.sector || '',
          attachments: item.attachments || [],
          log: item.log || [],
          procedure_deviation: item.procedure_deviation || null
        }
        if(infoModal.feedback.updated_at){
          infoModal.feedback.updated_at = moment(item.feedback.updated_at).format('DD/MM/YYYY \à\\s HH:mm')
        }

        infoModal.email_data = emailData || [];
        infoModal.primary_email_id = emailData?.[0]?.id ?? null;
        infoModal.wpp_groups = this.wppGroups;
        infoModal.email_groups = this.emailGroups;

        if(Object.keys(survey).length){
          let avaliacao;
          if(survey.grade === 1) avaliacao = '😫 Péssimo' 
          if(survey.grade === 2) avaliacao = '☹️ Ruim' 
          if(survey.grade === 3) avaliacao = '😐 Regular' 
          if(survey.grade === 4) avaliacao = '🙂 Bom' 
          if(survey.grade === 5) avaliacao = '😀 Ótimo' 
          const surveyObj = {
            avaliacao,
            reason: survey.reason
          }
          infoModal.survey = surveyObj;
        }
        await this.setLogChat(infoModal);

        this.$refs.dtModalPedidos.openModal();
    },

    formTelefone(tel) {
        tel=tel.replace(/\D/g,"")
        tel=tel.replace(/^(\d)/,"+$1")
        tel=tel.replace(/(.{3})(\d)/,"$1($2")
        tel=tel.replace(/(.{6})(\d)/,"$1)$2")
        if(tel.length == 12) {
            tel=tel.replace(/(.{1})$/,"-$1")
        } else if (tel.length == 13) {
            tel=tel.replace(/(.{2})$/,"-$1")
        } else if (tel.length == 14) {
            tel=tel.replace(/(.{3})$/,"-$1")
        } else if (tel.length == 15) {
            tel=tel.replace(/(.{4})$/,"-$1")
        } else if (tel.length > 15) {
            tel=tel.replace(/(.{4})$/,"-$1")
        }
        tel=tel.replace("("," (");
        tel=tel.replace(")",") ");

        return tel;
    },

    getPedidos(){
      this.items = [];
      let tempArray = [];
      axios.get('/solicitacoes/pedidos', {params: {start: this.filters.startDate, end: this.filters.endDate}}).then(({data}) => {
        if(data.length > 0){
          data.forEach(el => {
            if(el.pedido){
              let tipoString = '';
              el.pedido.tipo.forEach((tipo, index) => {
                if(index != el.pedido.tipo.length - 1){
                  tipoString += tipo + '<br>'
                } else {
                  tipoString += tipo;
                }
              })
              let objPedido = {
                solicitacao: el.pedido.solicitacao,
                tipo: tipoString,
                nome: el.client
              }
              let obj = {
                '_id': el._id,
                'requirement_type': 'solicitação de material',
                'telefone': el.client_id.substring(0, el.client_id.indexOf('@')) || el.client_id,
                'status': el.pedido.status,
                'created_at': el.created_at,
                'updated_at': el.updated_at,
                'chamado': el.protocol,
                'protocolo': el.attProtocol || '---',
                'dados': JSON.stringify([el.clientInfo]),
                'solicitacao': JSON.stringify(objPedido),
                'cnpj': el.cnpj || '0',
                'name': el.name || el.client,
                'tipo_atendimento': this.parseAttendanceType(el),
                'client_id': el.client_id,
                'updated_by': el.updated_by || '---',
                'created_by': el.created_by || '---',
                'recordType': 'mongo',
                'feedback': el.feedback,
                'notes': el.notes,
                'sector': el.sector || '',
                'attachments': el?.attachments,
                'log': el.log,
                'procedure_deviation': el.procedure_deviation || null
              }
              tempArray.push(obj)
            } else {
              let tempObj = {...el};
              tempObj.feedback = {}
              tempObj.requirement_type = 'solicitação de material'
              tempObj.recordType = 'mysql';
              tempObj.updated_by = '---';
              tempArray.push(tempObj);
            }
          })
        }
        this.items = tempArray;
        this.tryAutoOpen();
      })
    },

    procedureDeviationColumns(item) {
      const deviation = item?.procedure_deviation?.has_deviation ? item.procedure_deviation : null;
      return {
        'Desvio de Procedimento': deviation ? 'Sim' : 'Não',
        'Justificativa do Desvio': deviation?.justification || '',
        'Desvio Registrado por': deviation?.updated_by || '',
        'Data do Registro do Desvio': deviation?.updated_at ? moment(deviation.updated_at).format('DD/MM/YYYY HH:mm:ss') : '',
      };
    },
    resetFilters(){
      this.filters = {
        startDate: '',
        endDate: '',
      }
      this.statusFilter = '*'
      this.typeFilter = '*'
      this.sectorFilter = '*'
      this.deviationFilter = '*'
      this.searchTerm = ''
      this.getPedidos();
    },

    generateExcel() {
      const fieldsExcel = this.filteredItems.map(item => {
        const solicitacao = item.solicitacao ? JSON.parse(item.solicitacao) : {};
        const dadosCampo = item.dados ? JSON.parse(item.dados)[0] : {};
        let typeAttendance = item.tipo_atendimento;
        let solicitacaoDesc = '';
        if(solicitacao?.tipo?.includes('<br>')){
          solicitacaoDesc = solicitacao?.tipo.replaceAll('<br>', ' / ')
        }
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': this.parseCreator(item),
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Chamado': item.chamado,
          'Protocolo': item.protocolo,
          'Área Responsável': item.sector || 'Não atribuído',
          'Status': item.status,
          'Nome': (solicitacao.nome || item.name) || 'Não identificado',
          'Telefone': this.formTelefone(item.telefone) ,
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj ,
          'Estabelecimento': dadosCampo?.NomePonto || "",
          'Razão Social': dadosCampo?.NomeCliente || "",
          'Tipo de Atendimento': typeAttendance ? typeAttendance : 'Não Identificado',
          'Código do Ponto': dadosCampo?.CodigoPonto || "",
          'Base': dadosCampo?.Base || '',
          'Endereço': dadosCampo?.EnderecoPonto || "",
          'Solicitação': solicitacao?.solicitacao || "",
          'Descrição': (solicitacaoDesc || solicitacao?.tipo) || "",
          'Quantidade de GTV': solicitacao?.quantidade || "",
          ...this.procedureDeviationColumns(item),
        }
      }).sort((a,b) => {
        if(a['Data de criação'] < b['Data de criação']) return 1;
        if(a['Data de criação'] > b['Data de criação']) return -1;
      });

      const ordered = fieldsExcel;
      ordered.forEach(el => {
        el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
        el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
      })

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(ordered);
      XLSX.utils.book_append_sheet(wb, ws, "Planilha1");
      
      XLSX.writeFile(wb,'Solicitações - Pedidos.xlsx');
    },

    parseCreator(data){
      if(data.client === 'RequestByPhone') return 'Atendimento URA'
      if(data.client_id.includes('@s.whatsapp')) return 'Atendimento BOT'
      return data.created_by;
    },
    tryAutoOpen() {
      if (!this.autoOpenProtocol || this.autoOpenTriggered) return;
      const item = this.items.find(el => el.chamado === this.autoOpenProtocol);
      if (item) {
        this.autoOpenTriggered = true;
        this.getMsgLog(item);
      }
    },
  },
  mounted() {
    // this.filters.startDate = moment().startOf('month').format('YYYY-MM-DD');
  	// this.filters.endDate = moment().format('YYYY-MM-DD');
    this.getPedidos()
  },
  watch: {
    statusFilter(newVal) {
      if (newVal !== 'Fechado' && (this.filters.startDate || this.filters.endDate)) {
        this.filters.startDate = '';
        this.filters.endDate = '';
        this.getPedidos();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bgModalHeader{
  background-color: #1c859a;
  color: #FFFFFF;
}
.modal-content{
  border-radius: 3rem;
}
.custom-width {
  width: unset !important;
  border-radius: 10px !important;
}
#filter-group {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
#date-filter{
  display: flex;
  flex: 2;
  align-items: center;
}
.header-filter{
  display: flex;
  align-items: center;
  font-size: small;

  label {
    white-space: nowrap
  }
}

.filter-buttons{
  border-radius: 10px !important;
  font-weight: bold;
  color: white;
  margin-left: 5px;
  padding: 5px 10px;
  transition: 0.2s;
}

#search-button{
  background-color: #1c8498;
  border: 2px solid #1c8498;
  display: flex;
  align-items: center;
  gap: 4px;
}

#search-button:hover {
  background-color: #1c849845;
  color: #1c8498;
}

#reset-button{
  background-color: #e3342f;
  border: 2px solid #e3342f;
  display: flex;
  align-items: center;
  gap: 4px;
}

#reset-button:hover {
  background-color: #e3342f6e;
  color: #e3342f;
}

.search-container {
  width: 100% !important;
  input {
    width: 100% !important;
  }
}

label {
  margin: 0px 10px;
  font-weight: bold;
}
</style>

